/* Auto-generated from message-schema.proto */
import { IAuthTokenEntry } from './authentication-schemas';
import { IClientMetadata } from './clientmetadata-schema';
import { IType } from './type-schema';
export interface ICorrelationVector {
    id?: string;
    childCount?: number;
}
export interface IWorkflowLocation {
    edgeId?: number;
    workflowId?: number;
}
export enum MessageType {
    Input = 0,
    Exception = 1,
    WaitOn = 2,
    StopAndFilterWorkflow = 3
}
export interface IFilter {
    condition?: string;
}
export enum ExceptionType {
    Unknown = 0,
    NoOutput = 1,
    Authentication = 2,
    JoinTimedOut = 3,
    LambdaThrow = 4,
    LambdaErrorCallback = 5
}
export interface IException {
    exceptionType?: ExceptionType;
    message?: string;
    data?: Uint8Array;
}
export interface IBufferMessage {
    history?: IWorkflowLocation[];
    payload?: Uint8Array;
    payloadSchema?: IType;
    requestedSchema?: IType;
    messageType?: MessageType;
    tokens?: IAuthTokenEntry[];
    creationTime?: string;
    originString?: string;
    clientMetadata?: IClientMetadata;
    configVersion?: string;
    requestKey?: string;
    correlationVector?: ICorrelationVector;
    lambdaType?: string;
    useJsonMessage?: boolean;
    userId?: string;
}
